<template>
    <div class="annual-summary">
        <AnnualSummaryInfoCardComponent />
        <div class="annual-summary-blocks">
            <v-expansion-panels v-model="panel" v-if="blocks.length > 0">
                <v-expansion-panel
                    v-for="(block, idx) in blocks"
                    :key="`block_${block.id}`"
                    class="annual-summary-block"
                    :disabled="block.type === 'suggestions/warnings'"
                >
                    <v-expansion-panel-header>
                        {{ `${block.id} - ${getBlockName(block.type)}` }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <AnnualSummaryBlockTableComponent v-if="panel === idx" :block-id="block.id" />
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
        <AnnualSummaryConfigurationComponent />
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AnnualSummaryBlockTableComponent from '../../components/annual-summary/AnnualSummaryBlockTableComponent.vue'
import AnnualSummaryInfoCardComponent from '../../components/annual-summary/AnnualSummaryInfoCardComponent.vue'
import AnnualSummaryConfigurationComponent from '../../components/annual-summary/AnnualSummaryConfigurationComponent.vue'

export default {
    name: 'AnnualSummaryLayout',
    components: {
        AnnualSummaryInfoCardComponent,
        AnnualSummaryBlockTableComponent,
        AnnualSummaryConfigurationComponent,
    },
    data() {
        return {
            panel: null,
            opened: 0,
        }
    },
    computed: {
        ...mapState('annualSummary', ['blocks']),
    },
    async mounted() {
        await this.fetchBlocks()
        await this.fetchCountries()
        await this.fetchQuarters()
    },
    methods: {
        ...mapActions('annualSummary', ['fetchBlocks']),
        ...mapActions('quarter', ['fetchQuarters']),
        ...mapActions('country', ['fetchCountries']),
        getBlockName(name) {
            name = name.charAt(0).toUpperCase() + name.slice(1)
            return name.replaceAll('_', ' ').replaceAll('-', ' ')
        },
    },
}
</script>

<style scoped></style>
